import { makeStyles } from "@material-ui/core";
import { DashboardHeader } from "pages/admin/dashboard/components/general";
const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: 5, },
    '&::-webkit-scrollbar-thumb': { background: '#999999' }
  },
  chart: {
    width: '100%',
    height: '100%',
  },
  wrapRow: {
    padding: "5px 10px", borderBottom: "1px solid #F3f3f3",
    cursor: 'pointer'
  },
  wrapCreateInfo: {
    display: 'flex',
    marginTop: 5
  },
  newCreate: { color: "#707070", fontSize: "12px", marginRight: "10px" },
  newCreateBy: { color: "#707070", fontSize: "12px" },
}));


const data = [
  {
    newsName: "ยกเลิก Smart T,S,I",
    started: '5 hours ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
  {
    newsName: "New target industry",
    started: '12 hours ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
  {
    newsName: "New Smart Visa Type",
    started: '1 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'
  },
  {
    newsName: "เปลี่ยนเวลาทำการ เดือน ธันวาคม 2564",
    started: '3 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },

  {
    newsName: "แก้ไขกฎระเบียบการยื่นคำขอ",
    started: '4 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
]

function News() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="News" />
      </div>
      <div className={classes.wrapChart}>
        {
          data.map((d, index) => (
            <div key={index} className={classes.wrapRow}>
              <div style={{ color: "#1a0dab", fontSize: "14px" }}>
                {d.newsName}
              </div>

              <div className={classes.wrapCreateInfo}>
                <div className={classes.newCreate}>
                  {d.started}
                </div>
                <div className={classes.newCreateBy}>
                  {d.createBy}
                </div>
              </div>
            </div>
          ))
        }

      </div>
    </>
  )
}


export default News;